function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "dxtu19txta",
  colorInterpolationFilters: "auto"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#dxtu19txta)",
  transform: "translate(-280.000000, -392.000000) translate(0.000000, 216.000000) translate(0.000000, 160.000000)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#FFDE00",
  transform: "translate(280.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.582 3.831c-.042.61-.107 1.075-.06 1.526.076.737.413 1.446.996 1.977.985-.31 1.224-.654 1.396-1.03 1.106.57 1.59 1.587 1.586 2.671 0 .974-.392 1.856-1.026 2.494C9.84 12.106 8.966 12.5 8 12.5c-.966 0-1.84-.394-2.474-1.031-.633-.637-1.025-1.517-1.026-2.488.028-1.215.415-2.363 1.076-3.32.516-.746 1.198-1.376 2.006-1.83z"
}))))));
const SvgUiIconUtility16GasCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUiIconUtility16GasCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ui-icon-utility-16-gas-circle.4a5c5e2a.svg";
export { ForwardRef as ReactComponent };